export default __webpack_public_path__ + "static/media/logo.a3125422.svg";